import { render, staticRenderFns } from "./SubscriptionChange.vue?vue&type=template&id=61d51e19&scoped=true"
import script from "./SubscriptionChange.vue?vue&type=script&lang=js"
export * from "./SubscriptionChange.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionChange.vue?vue&type=style&index=0&id=61d51e19&prod&lang=css"
import style1 from "./SubscriptionChange.vue?vue&type=style&index=1&id=61d51e19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d51e19",
  null
  
)

export default component.exports